import { render, staticRenderFns } from "./color_widget.vue?vue&type=template&id=a05ad990&scoped=true"
import script from "./color_widget.vue?vue&type=script&lang=js"
export * from "./color_widget.vue?vue&type=script&lang=js"
import style0 from "./color_widget.vue?vue&type=style&index=0&id=a05ad990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05ad990",
  null
  
)

export default component.exports